import { query_arrange_shift_list1 } from 'liyu-pc-base/api/org-model';

export default () => {
  const search_config: any = {
    model: {
      aim_org_id: 12,
      is_active: true,
      pageSize: 50,
    },
    watch: ['aim_org_id'],
  };
  return {
    getData: query_arrange_shift_list1,
    searchConfig: search_config,
  };
};
